var render = function render(){var _vm=this,_c=_vm._self._c;return _c('issue-risk-score',{staticClass:"issue-risk-score",attrs:{"issue":_vm.item}})
}
var staticRenderFns = []

export { render, staticRenderFns }